/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiActionEventLog } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ActionEventLogsController.
 */
export class ActionEventLogsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /action_event_logs:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiActionEventLog>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiActionEventLog>>>('/action_event_logs:query', query);
    }

    /**
     * Calls POST /action_event_logs:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiActionEventLog>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiActionEventLog>>, ListRequest>('/action_event_logs:query', listRequest, query);
    }

    /**
     * Calls GET /action_event_logs/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiActionEventLog>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiActionEventLog>>(`/action_event_logs/${primaryId}`, query);
    }

    /**
     * Calls POST /action_event_logs:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiActionEventLog>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiActionEventLog>>, ListRequestWithIds>('/action_event_logs:batch', listRequest, query);
    }
}
